import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { ReactNode } from 'react';

interface OfferCardProps {
  icon: ReactNode;
  title: string;
  tagline: string;
  description: string;
  duration: string;
  cta: string;
  ctaLink: string;
  featured?: boolean;
}

const OfferCard = ({ icon, title, tagline, description, duration, cta, ctaLink, featured }: OfferCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className={`relative p-8 rounded-xl transition-all duration-300 ${
        featured
          ? 'bg-gradient-to-br from-primary/10 to-accent/10 border-2 border-primary shadow-lg'
          : 'bg-white border border-gray-200 shadow-sm hover:shadow-md'
      }`}
    >
      {featured && (
        <div className="absolute -top-3 left-6 bg-primary text-white text-sm font-semibold px-3 py-1 rounded-full">
          Offre phare
        </div>
      )}

      <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-6 ${
        featured ? 'bg-primary/20 text-primary' : 'bg-primary/10 text-primary'
      }`}>
        {icon}
      </div>

      <h3 className="text-sm font-semibold text-primary uppercase tracking-wide mb-2">
        {tagline}
      </h3>
      <h4 className="text-2xl font-bold text-gray-900 mb-4">{title}</h4>
      <p className="text-gray-600 mb-6">{description}</p>

      <div className="mb-6 pt-6 border-t border-gray-200">
        <p className="text-sm text-gray-500">
          <span className="font-semibold">Durée :</span> {duration}
        </p>
      </div>

      <a
        href={ctaLink}
        className="inline-flex items-center gap-2 text-primary hover:text-primary-light font-semibold transition-colors"
      >
        {cta}
        <ArrowRight className="h-4 w-4" />
      </a>
    </motion.div>
  );
};

export default OfferCard;
